class DragScroll extends HTMLElement {
  constructor() {
    super();
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.isDragging = false;
  }

  connectedCallback() {
    // Determine the scrollable container. It can be this element itself or a child element.
    this.container = this.querySelector('[data-drag-container]') || this.firstElementChild || this;

    this.container.addEventListener('mousedown', this.#onMouseDown.bind(this));
    this.container.addEventListener('mouseleave', this.#onMouseLeave.bind(this));
    this.container.addEventListener('mouseup', this.#onMouseUp.bind(this));
    this.container.addEventListener('mousemove', this.#onMouseMove.bind(this));

    // Prevent default browser drag behavior on links and images to avoid conflicts
    this.container.querySelectorAll('a, img').forEach(el => {
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });

    // Use capture phase to intercept clicks before they reach the links
    this.container.addEventListener('click', this.#onClick.bind(this), true);
  }

  #onMouseDown(e) {
    this.isDown = true;
    this.container.classList.add('is-dragging');
    this.startX = e.pageX - this.container.offsetLeft;
    this.scrollLeft = this.container.scrollLeft;
    this.isDragging = false;
  }

  #onMouseLeave() {
    this.isDown = false;
    this.container.classList.remove('is-dragging');
  }

  #onMouseUp() {
    this.isDown = false;
    this.container.classList.remove('is-dragging');
  }

  #onMouseMove(e) {
    if (!this.isDown) return;

    e.preventDefault(); // Prevents text selection
    const x = e.pageX - this.container.offsetLeft;
    const walk = (x - this.startX) * 1.5; // Scroll speed multiplier

    // Only mark as dragging if the user actually moved the mouse by a few pixels
    if (Math.abs(walk) > 5) {
      this.isDragging = true;
    }

    this.container.scrollLeft = this.scrollLeft - walk;
  }

  #onClick(e) {
    if (this.isDragging) {
      e.preventDefault();
      e.stopPropagation();
      this.isDragging = false;
    }
  }
}

if (!customElements.get('drag-scroll')) {
  customElements.define('drag-scroll', DragScroll);
}
